import { useId } from "react";
import { useCatalogSuppliers } from "../api";

/**
 * The hop company on a bag of hops, typed or picked from the hop companies the catalog knows. Anything
 * typed is kept; one the catalog knows by another name ("YCH") is stored under its name.
 */
export function BrandInput({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  const listId = useId();
  const { data: sellers = [] } = useCatalogSuppliers();
  const brands = sellers.filter((s) => s.kind === "hop_company");
  return (
    <>
      <input
        className="input"
        list={listId}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      <datalist id={listId}>
        {brands.map((b) => (
          <option key={b.id} value={b.name} />
        ))}
      </datalist>
    </>
  );
}
